/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react'
import { Row, Col, Input, Form, Select, DatePicker } from 'antd'
import _ from 'lodash'
import { observer } from 'mobx-react'
import { compose } from 'recompose'
import { 
	GENERIC_LOOKUP, DISABILITY_TYPE, ILLNESSES, RESPIRATORY_ISSUES
} from '../../../../constants/lookup'

class Index extends Component {
	constructor(props) {
		super(props)

		this.state = {
		}
	}

	render() {
		const { form } = this.props
		const { getFieldDecorator, getFieldValue } = form
        
		return (
			<React.Fragment>
				<Row gutter={16}>
					<Col md={3} sm={24}>
						<Form.Item label='PWD'>
							{ getFieldDecorator('pwd', {
								rules: [{
									required: false,
									message: 'This field is required.'
								}]
							})
							(
								<Select placeholder='Select'>
									{
										GENERIC_LOOKUP.map((i, key) => (
											<Select.Option key={key} value={i.value}>{i.value}</Select.Option>
										))
									}
								</Select>
							)}
						</Form.Item>
					</Col>
					<Col md={4} sm={24}>
						<Form.Item label='Disability Type'>
							{ getFieldDecorator('disability_type', {
								rules: [{
									required: false,
									message: 'This field is required.'
								}]
							})
							(
								<Select 
									disabled={getFieldValue('pwd') && 
										(_.isEqual(getFieldValue('pwd'), 'No') || _.isEqual(getFieldValue('pwd'), 'Not applicable'))}
									placeholder='Select Disability type'
								>
									{
										DISABILITY_TYPE.map((i, key) => (
											<Select.Option key={key} value={i.value}>{i.value}</Select.Option>
										))
									}
								</Select>
							)}
						</Form.Item>
					</Col>
					<Col md={4} sm={24}>
						<Form.Item label='Other disability'>
							{ getFieldDecorator('other_disability', {
								rules: [{
									required: (getFieldValue('disability_type') && 
										_.isEqual(getFieldValue('disability_type'), 'Others, specify')),
									message: 'This field is required.'
								}, {
									validator: (rule, value, callback) => {
										if (value && ((value.length > 0) && (!value.replace(/\s/g, '').length))) {
											callback('only white space detected.')
										}
										callback()
									}
								}]
							})
							(
								<Input 
									placeholder='Enter other disability' 
									disabled={!(getFieldValue('disability_type') && 
										_.isEqual(getFieldValue('disability_type'), 'Others, specify'))}
								/>
							)}
						</Form.Item>
					</Col>
					<Col md={3} sm={24}>
						<Form.Item label='With PWD ID'>
							{ getFieldDecorator('with_pwd_id', {
								rules: [{
									required: false,
									message: 'This field is required.'
								}]
							})
							(
								<Select 
									disabled={getFieldValue('pwd') && 
										(_.isEqual(getFieldValue('pwd'), 'No') || _.isEqual(getFieldValue('pwd'), 'Not applicable'))}
									placeholder='Select'
								>
									{
										GENERIC_LOOKUP.map((i, key) => (
											<Select.Option key={key} value={i.value}>{i.value}</Select.Option>
										))
									}
								</Select>
							)}
						</Form.Item>
					</Col>
					<Col md={3} sm={24}>
						<Form.Item label='With Senior Citizen ID'>
							{ getFieldDecorator('with_senior_id', {
								rules: [{
									required: false,
									message: 'This field is required.'
								}]
							})
							(
								<Select placeholder='Select'>
									{
										GENERIC_LOOKUP.map((i, key) => (
											<Select.Option key={key} value={i.value}>{i.value}</Select.Option>
										))
									}
								</Select>
							)}
						</Form.Item>
					</Col>
					<Col md={3} sm={24}>
						<Form.Item label='Pregnant'>
							{ getFieldDecorator('pregnant', {
								rules: [{
									required: false,
									message: 'This field is required.'
								}]
							})
							(
								<Select placeholder='Select'>
									{
										GENERIC_LOOKUP.map((i, key) => (
											<Select.Option key={key} value={i.value}>{i.value}</Select.Option>
										))
									}
								</Select>
							)}
						</Form.Item>
					</Col>
					<Col md={3} sm={24}>
						<Form.Item label='Teenage Pregnancy?'>
							{ getFieldDecorator('is_teenage_pregnancy', {
								rules: [{
									required: false,
									message: 'This field is required.'
								}]
							})
							(
								<Select placeholder='Select'>
									{
										GENERIC_LOOKUP.map((i, key) => (
											<Select.Option key={key} value={i.value}>{i.value}</Select.Option>
										))
									}
								</Select>
							)}
						</Form.Item>
					</Col>
					<Col md={3} sm={24}>
						<Form.Item label='Maternal death?'>
							{ getFieldDecorator('maternal_death', {
								rules: [{
									required: false,
									message: 'This field is required.'
								}]
							})
							(
								<Select placeholder='Select'>
									{
										GENERIC_LOOKUP.map((i, key) => (
											<Select.Option key={key} value={i.value}>{i.value}</Select.Option>
										))
									}
								</Select>
							)}
						</Form.Item>
					</Col>
					<Col md={3} sm={24}>
						<Form.Item label='Covid Contacted?'>
							{ getFieldDecorator('contacted_covid', {
								rules: [{
									required: false,
									message: 'This field is required.'
								}]
							})
							(
								<Select placeholder='Select'>
									{
										GENERIC_LOOKUP.map((i, key) => (
											<Select.Option key={key} value={i.value}>{i.value}</Select.Option>
										))
									}
								</Select>
							)}
						</Form.Item>
					</Col>
					<Col md={3} sm={24}>
						<Form.Item label='Solo Parent'>
							{ getFieldDecorator('solo_parent', {
								rules: [{
									required: false,
									message: 'This field is required.'
								}]
							})
							(
								<Select placeholder='Select'>
									{
										GENERIC_LOOKUP.map((i, key) => (
											<Select.Option key={key} value={i.value}>{i.value}</Select.Option>
										))
									}
								</Select>
							)}
						</Form.Item>
					</Col>
					<Col md={4} sm={24}>
						<Form.Item label='Height (meters)'>
							{ getFieldDecorator('height', {
								rules: [{
									required: false,
									message: 'This field is required.'
								}, {
									validator: (rule, value, callback) => {
										if (value && ((value.length > 0) && (!value.replace(/\s/g, '').length))) {
											callback('only white space detected.')
										}
										callback()
									}
								}]
							})
							(
								<Input 
									placeholder='Enter Height (in meters)' 
									type='number'
								/>
							)}
						</Form.Item>
					</Col>
					<Col md={4} sm={24}>
						<Form.Item label='Weight (kilograms)'>
							{ getFieldDecorator('weight', {
								rules: [{
									required: false,
									message: 'This field is required.'
								}, {
									validator: (rule, value, callback) => {
										if (value && ((value.length > 0) && (!value.replace(/\s/g, '').length))) {
											callback('only white space detected.')
										}
										callback()
									}
								}]
							})
							(
								<Input 
									placeholder='Enter Weight (in kilograms)' 
									type='number'
								/>
							)}
						</Form.Item>
					</Col>
					<Col md={6} sm={24}>
						<Form.Item label='Non-communicable/Chronic disease'>
							{ getFieldDecorator('illness', {
								rules: [{
									required: false,
									message: 'This field is required.'
								}]
							})
							(
								<Select 
									placeholder='Select Type of Illness'
								>
									{
										ILLNESSES.map((i, key) => (
											<Select.Option key={key} value={i.value}>{i.value}</Select.Option>
										))
									}
								</Select>
							)}
						</Form.Item>
					</Col>
					<Col md={6} sm={24}>
						<Form.Item label='Other non-communicable/Chronic disease'>
							{ getFieldDecorator('other_illness', {
								rules: [{
									required: (getFieldValue('illness') && 
										_.isEqual(getFieldValue('illness'), 'Other specify')),
									message: 'This field is required.'
								}, {
									validator: (rule, value, callback) => {
										if (value && ((value.length > 0) && (!value.replace(/\s/g, '').length))) {
											callback('only white space detected.')
										}
										callback()
									}
								}]
							})
							(
								<Input 
									placeholder='Enter other type of illness' 
									disabled={!(getFieldValue('illness') && 
										_.isEqual(getFieldValue('illness'), 'Other specify'))}
								/>
							)}
						</Form.Item>
					</Col>
					<Col md={6} sm={24}>
						<Form.Item label='Respiratory Issue'>
							{ getFieldDecorator('respiratory_issue', {
								rules: [{
									required: false,
									message: 'This field is required.'
								}]
							})
							(
								<Select 
									placeholder='Select Type of Respiratory issue'
								>
									{
										RESPIRATORY_ISSUES.map((i, key) => (
											<Select.Option key={key} value={i.value}>{i.value}</Select.Option>
										))
									}
								</Select>
							)}
						</Form.Item>
					</Col>
					<Col md={6} sm={24}>
						<Form.Item label='Other respiratory issue'>
							{ getFieldDecorator('other_respiratory_issue', {
								rules: [{
									required: (getFieldValue('respiratory_issue') && 
										_.isEqual(getFieldValue('respiratory_issue'), 'Other specify')),
									message: 'This field is required.'
								}, {
									validator: (rule, value, callback) => {
										if (value && ((value.length > 0) && (!value.replace(/\s/g, '').length))) {
											callback('only white space detected.')
										}
										callback()
									}
								}]
							})
							(
								<Input 
									placeholder='Enter other type of respiratory issue' 
									disabled={!(getFieldValue('respiratory_issue') && 
										_.isEqual(getFieldValue('respiratory_issue'), 'Other specify'))}
								/>
							)}
						</Form.Item>
					</Col>
				</Row>
			</React.Fragment>
		)
	}
}

const composed = compose(
	observer
)

export default composed(Index)
